var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-trackvideo-card--novideo"},[_c('div',{staticClass:"mc-trackvideo__wrapper-no-video"},[_c('img',{attrs:{"src":_vm.getAsset('secondaryLogo', 'sidebarMinimize')}}),_c('p',[_vm._v(_vm._s(_vm.$t('trackVideo.state.noVideo')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }